module.exports = __webpack_public_path__ + "static/media/info-gray.272f134b.svg";